import {svgIconWrapper} from '../svg-icon-wrapper';

import AcuityRegular from './acuity-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <AcuityRegular {...rest} />;
}

SvgComponent.iconName = 'acuityRegular';

export const AcuityRegularIcon = svgIconWrapper(SvgComponent);
